import { useSyncExternalStore } from "react";
import { getTrainer } from "../../trainer/session.ts";

export function useTrainer() {
  const session = getTrainer();
  return useSyncExternalStore(session.subscribe, session.getSnapshot, session.getSnapshot);
}
